import { useData, useDispatch } from "./DataContext.js";
import { style } from "./Style.js";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ListGroup from "react-bootstrap/ListGroup";

import ImpactList from "./ImpactList.js";
import SolutionTitle from "./SolutionTitle.js";
//import ReliabilityBadge from "./ReliabilityBadge.js";
//import ApplicationBadge from "./ApplicationBadge.js";

export default function EndModal (props)
{
    const gData = useData();
    switch (gData.gameId)
    {
	case "2cpo": return CpoEndModal(props);
	case "ada": return AdaEndModal(props);
	default: return (<></>);
    }
}


function CpoEndModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const themeId = gData.state.currentThemeId;

    function closeEnd ()
    {
	gDispatch({ type: "endTheme" });
	gDispatch({ type: "closeModal", modal: "end" });
    }

    let themeTitle = "";
    if (themeId !== null) themeTitle = gData.content.themes[themeId].title;

    const solutionItems = Object.values(gData.content.solutions)
				.filter((solution) => solution.themeId === themeId)
				.map((solution) => {
				    return (<SolutionTitle key={solution.id} solutionId={solution.id}/>);
				});

    const data = [];

    let min = null;
    if (themeId !== null) min = Math.round((gData.state.themes[themeId].endRealTime - gData.state.themes[themeId].startRealTime) / 60000);

    data.push({
	var: "Temps de jeu",
	value: min + " min"
    });

    const myQuestions = Object.values(gData.state.choiceQuests).filter((quest) => quest.state === "closed");
    
    data.push({
	var: "Questions posées",
	value: myQuestions.length
    });

    const allSolutions = Object.values(gData.content.solutions).filter((solution) => solution.themeId === themeId);
    const mySolutions = allSolutions.filter((solution) => gData.state.solutions[solution.id].found);
    
    data.push({
	var: "Solutions collectées",
	value: mySolutions.length + " / " + allSolutions.length
    });

    
    const allDocuments = Object.values(gData.content.documents).filter((document) => document.themeId === themeId && document.type !== "info");
    const myDocuments = allDocuments.filter((document) => gData.state.documents[document.id].found);
    
    data.push({
	var: "Documents collectées",
	value: myDocuments.length + " / " + allDocuments.length
    });


    const reliability = Object.values(gData.state.reports)
			      .filter((report) => gData.content.solutions[report.id].themeId === themeId && report.result !== null)
			      .reduce((reliability, report) => reliability += report.result.reliability, 0);

    data.push({
	var: "Fiabilité globale",
	value: Math.round(reliability/allDocuments.length*100)+"%"
    });
    
    
    const dataList = data.map((d, index) => {
	if (d.var === "") { return (<div key={index} className="m-3"/>); }
	return (
	    <ListGroup.Item key={index} className="d-flex justify-content-start align-items-center border-dark">
		<div className="text-end fs-5" style={{ width: "200px" }}>{d.var}</div>
		<div className="text-end fw-bold fs-5" style={{ width: "100px" }}>{d.value}</div>
	    </ListGroup.Item>
	);
    });
    

    const image = "url(" + gData.gameId + "/pictures/" + gData.content.params.titlePicture + ")";
    //  style={{ backgroundImage: `url(ada/pictures/title-dark.jpg)`, backgroundRepeat: "no-repeat" }}
    
    return (
	<Modal
	    backdropClassName="opacity-100"
	    dialogClassName="modal-xxl"
	    contentClassName="modal-content-xxl"
	    show={gData.state.showModals.end}
	    onHide={closeEnd}
	    scrollable={true}
	    centered
	>
	    <Modal.Header className="d-flex align-items-center justify-content-between bg-light">
		<Modal.Title className="m-auto text-uppercase fs-3">{themeTitle}</Modal.Title>
	    </Modal.Header>
	    <Modal.Body className="pb-0" style={{ backgroundImage: image, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
		<div className="h-100 d-flex justify-content-start">
		    <img src="2cpo/pictures/chars/directeur.png" alt="Directrice de Pulple & Cie" className="h-100" style={{ marginLeft: "-100px", marginRight: "-100px" }}/>
		    <div className="w-100 d-flex justify-content-between gap-4">
			<div className="w-100 d-flex flex-column align-items-center">
			    <div className="text-center">
				<div className="text-uppercase fs-5 fw-medium mb-2">Données de mission</div>
				<ListGroup>
				    {dataList}
				</ListGroup>
			    </div>
			    <div className="w-100 mt-4 text-center">
				<div className="text-uppercase fs-5 fw-medium">Évolution de l'entreprise</div>
				<ImpactList type="result"/>
			    </div>
			</div>
			<div className="text-center">
			    <div className="text-uppercase fs-5 fw-medium mb-2">Solutions étudiées</div>
			    <div className="d-flex flex-column gap-2">
				{solutionItems}
			    </div>
			</div>
		    </div>
		</div>		
	    </Modal.Body>
	    <Modal.Footer>
		<Button variant="primary" onClick={closeEnd}>Terminer</Button>
	    </Modal.Footer>
	</Modal>
    );
}


function AdaEndModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const themeId = gData.state.currentThemeId;

    function closeEnd () { gDispatch({ type: "closeModal", modal: "end" }); }

    const end = gData.state.badges["fin"] !== undefined && gData.state.badges["fin"].state === "opened";

    let result = (
	<>
	    <div>Malheureusement, Max n'est pas allée au bout de cette enquête...</div>
	    <div>Elle fera mieux la prochaine fois !</div>
	</>
    );

    if (end)
    {
	result = (
	    <>
		<div>Bravo ! Max a réussi à démasquer Pierre.</div>
		<div>Elle est arrivée au terme de son enquête grâce à vous !</div>
	    </>
	);
    }

    const data = [];

    let min = null;
    if (themeId !== null) min = Math.round((gData.state.themes[themeId].endRealTime - gData.state.themes[themeId].startRealTime) / 60000);

    data.push({
	var: "Temps de jeu",
	value: min + " min"
    });

    data.push({
	var: "Score de cybersécurité",
	value: gData.state.score + "%"
    });

    /* data.push({
       var: "Nombre d'erreurs",
       value: gData.state.errors
     * });
     */
    /* const choiceNb = Object.values(gData.state.badges).filter((badge) => badge.state === "opened" && badge.id.startsWith("done-choice-")).length;
     * data.push({
       var: "Nombre de questions",
       value: choiceNb
     * }); */

    data.push({ var: "", value: "" });

    const allInfos = Object.values(gData.content.items).filter((item) => item.type === "info" && item.themeId === themeId);
    const myInfos = allInfos.filter((item) => gData.state.items[item.id].found);
    
    data.push({
	var: "Informations collectées",
	value: myInfos.length + "/" + allInfos.length
    });

    const allIndices = Object.values(gData.content.items).filter((item) => item.type === "indice" && item.themeId === themeId);
    const myIndices = allIndices.filter((item) => gData.state.items[item.id].found);
    
    data.push({
	var: "Indices collectés",
	value: myIndices.length + "/" + allIndices.length
    });

    //data.push({ var: "", value: "" });

    const allBps = Object.values(gData.content.items).filter((item) => item.type === "bp" && item.themeId === themeId);
    const myBps = allBps.filter((item) => gData.state.items[item.id].found);

    /* data.push({
       var: "Conseils collectés",
       value: myBps.length + "/" + allBps.length
     * }); */

    const givableBps = allBps.reduce((count, item) => count + item.toCharIds.length, 0);
    const givenBps = myBps.reduce((count, item) => count + gData.state.items[item.id].appliedToCharIds.length, 0);

    data.push({
	var: "Conseils donnés",
	value: givenBps + "/" + givableBps
    });

    const dataList = data.map((d, index) => {
	if (d.var === "") { return (<div key={index} className="m-4"/>); }
	return (
	    <ListGroup.Item key={index} className="mt-1 d-flex justify-content-start align-items-center border-dark">
		<div className="text-end fs-5" style={{ width: "300px" }}>{d.var}</div>
		<div className="text-end fw-bold fs-5" style={{ width: "100px" }}>{d.value}</div>
	    </ListGroup.Item>
	);
    });

    const bgImageSrc = gData.gameId + "/pictures/title.jpg";
    
    return (
	<Modal
	    backdropClassName="opacity-100"
	    dialogClassName="modal-xxl bg-transparent"
	    contentClassName={"modal-content-xxl border " + style.modal.content.className}
	    show={gData.state.showModals.end}
	    onHide={closeEnd}
	    centered
	    backdrop="static"
            keyboard={false}
			       style={{ backgroundImage: "url(" + bgImageSrc + ")", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
	>
	    <Modal.Body className="bg-transparent text-light py-5">
		<h1 className="w-100 mb-4 text-center text-uppercase fs-1" style={{ textShadow: "#AAF 1px 1px 10px" }}>Qui veut les données d'Irène Hooper&nbsp;?</h1>
		<div className="text-center fs-3 my-5">
		    {result}
		</div>
		<div className="d-flex align-items-center justify-content-center gap-5">
		    <div className="fs-4">{dataList}</div>
		    <div><img src={"ada/pictures/chars/robot-big.png"} alt="Robot médical" height="300px"/></div>
		</div>
		<div className="text-center mt-5">
		    <Button variant="light" size="lg" onClick={closeEnd} style={{ width: "300px" }}>Continuer de jouer</Button>
		</div>
	    </Modal.Body>
	</Modal>
    );
}


